module.exports = __webpack_public_path__ + "static/img/csyxst.0142256.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/csyxst.png
// module id = OTHp
// module chunks = 0